'use client';

import { CSSProperties, Fragment } from 'react';

import * as S from './styles';
import FooterCorpo from '@/components/organisms/FooterCorpo';
import estaNoContextoHome from '@/utils/verificarCaminhoURL';
import { usePathname } from 'next/navigation';
import useBreakpoint from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function Footer() {
  const { breakpoint } = useBreakpoint();
  const caminhoURL = usePathname();

  if (
    (!estaNoContextoHome(caminhoURL) && breakpoint === 'mobile') ||
    ['/monte-seu-plano', '/pagamento-cartao'].includes(caminhoURL) ||
    caminhoURL.includes('/customizar-plano') ||
    (caminhoURL.includes('/refazer-pedido') && breakpoint === 'mobile') ||
    caminhoURL.includes('/minha-carteira/cadastrar-assinatura')
  )
    return <Fragment></Fragment>;

  const style: CSSProperties = ['/assinatura', '/produto'].some((text) =>
    caminhoURL.startsWith(text),
  )
    ? {
        backgroundColor: theme.colors.neutral.neutral[2],
        paddingBottom: breakpoint === 'mobile' ? 113 : 0,
      }
    : { backgroundColor: theme.colors.accent.accent[3] };

  return (
    <S.Container
      $removerMarginTop={
        breakpoint === 'desktop' && caminhoURL.includes('minha-conta')
      }
      style={style}
    >
      <FooterCorpo />
    </S.Container>
  );
}
